import React from "react";
import SavedPlans from "../../components/templates/Plans/User/SavedPlans";
import withRequireAuth from "../../components/molecules/hoc/auth/withRequireAuth";
import TemplateSEO from "../../components/molecules/seo/TemplateSEO";

function SavedPlansPage() {
    return (
        <>
            <TemplateSEO
                title="Saved house plans"
                urlPath="plans/saved-plans"
            />
            <SavedPlans />
        </>
    );
}

export default withRequireAuth(SavedPlansPage);
